import React, { useEffect, useRef, useState } from "react";
import { getuserdetail, logout } from "../api";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const Header = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState([]);
  const [open, setOpen] = useState(false);
  const ref = useRef();

  const location = useLocation();

  // Extract the token from the URL search parameters
  const searchParams = new URLSearchParams(location.search);
  const token = searchParams.get("token");

  const handleClickOutside = (event) => {
    if (
      ref.current &&
      !ref.current.contains(event.target) &&
      !event.target.closest(".togglebtn")
    ) {
      setOpen(false);
    }
  };

  useEffect(() => {
    getuser();

    document.addEventListener("mousedown", handleClickOutside);
    // Cleanup event listener on component unmount
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  let getuser = async () => {
    try {
      let detail = await getuserdetail();
      if (detail.data) {
        setUser(detail.data);
      } else {
        console.log(detail.error.detail);
        setUser("User");
      }
    } catch (e) {
      toast.error(e);
    }
  };

  const handleclick = async () => {
    setOpen(false);
    toast.info("Signing out, please wait", {
      autoClose: false,
    });
    let result = await logout();
    if (result.data) {
      toast.dismiss();
      toast.success("Signed out successfully");
      localStorage.removeItem("token");
      navigate("/login/signIn");
    } else {
      toast.dismiss();
      toast.error(result.error);
    }
  };

  console.log(user);

  return (
    <div className="w-full py-3 px-6 sm:px-10 flex justify-between h-fit sm:h-20 relative z-10 ">
      <div className="w-fit sm:w-4/12 h-fit">
        <div className="  w-fit flex flex-col ">
          <Link to={"/home"}>
            <img
              className="h-[35px] sm:h-[40px]"
              src={process.env.PUBLIC_URL + "/images/login/headerlogo.svg"}
              alt="xpress_logo"
            />
          </Link>
          <p className=" text-[8px]  flex gap-1 text-black  justify-end">
            Powered by
            <Link target="_blank" to={"https://www.transforma.in/"}>
              <img
                className="h-[9px] sm:h-[10px]"
                src={process.env.PUBLIC_URL + "/images/logos/Transforma.svg"}
                alt="xpress_logo"
              />
            </Link>
          </p>
        </div>
      </div>
      {/* <div className="w-4/12 flex justify-center">
        <Link to={"/home"}>
          <img
            src={process.env.PUBLIC_URL + "/images/login/headerlogo.svg"}
            alt="transforma_logo"
          />
        </Link>
      </div> */}
      <div className="w-4/12 items-center flex justify-end relative">
        <button
          onClick={() => setOpen(!open)}
          className="flex gap-2 items-center togglebtn"
        >
          <p> {user.username}</p>
          {!token && (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className={`w-5 h-5 ${open ? "rotate-180" : ""}`}
            >
              <path d="M6 9l6 6 6-6" />
            </svg>
          )}
        </button>
        {open && !token && (
          <div
            ref={ref}
            className="absolute top-[100%] bg-white px-5 py-3 -right-8 rounded-[12px] shadow-highlig"
          >
            <button
              onClick={() => handleclick()}
              className="h-9 py-3 px-4 flex items-center  rounded-[36px] bg-F37021 text-white font-medium"
            >
              Sign Out
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Header;
